"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_NOT_FIT_REPLACEMENT = exports.MIN_VISIBLE_SUBTITLE_CONTENT_HEIGHT = exports.MAX_VISIBLE_CONTENT_HEIGHT = exports.MAX_VISIBLE_CONTENT_WIDTH = exports.PADDING_TOP_SUBTITLE = exports.PADDING_TOP_TITLE = exports.MAX_LIGHTEN_FRACTION = void 0;
exports.MAX_LIGHTEN_FRACTION = 0.6;
exports.PADDING_TOP_TITLE = 16;
exports.PADDING_TOP_SUBTITLE = 32;
exports.MAX_VISIBLE_CONTENT_WIDTH = 40;
exports.MAX_VISIBLE_CONTENT_HEIGHT = 18;
exports.MIN_VISIBLE_SUBTITLE_CONTENT_HEIGHT = 38;
exports.LABEL_NOT_FIT_REPLACEMENT = '(...)';
